unit CostingListPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  Rtti,
  smx.webcore.types;

type
  TCostingListForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetTitle: TStringField;
    MainDatasetValidFrom: TDateTimeField;
    MainDatasetValidTo: TDateTimeField;
    procedure WebFormShow(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
  private
    { Private declarations }

  protected
    [async]
    procedure EditRecord(const ARecordId: string); async; override;

    procedure PrepareForm; override;

    procedure LoadData; override;
    procedure SearchData(const Value: string); override;

    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;

  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  CostingListForm: TCostingListForm;

implementation

{$R *.dfm}

uses
  SMX.Web.Layout.Utils,
  XData.Web.Client,
  MainDataModule,
  CostingEditPage,
  System.StrUtils;

procedure TCostingListForm.DataTableGetCellChildren(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
begin
  inherited;

  if Sender is TDBTableControl then
  begin
    // hide first column
    if ACol = 0 then
    begin
      AElement.Element.style.setProperty('display', 'none');

    end;

  end;

end;

procedure TCostingListForm.EditRecord(const ARecordId: string);
var
  AForm: TCostingEditForm;

begin
  if ARecordId = '' then
  begin
    MainDataset.Append;
    Await(MainData.OpenCostingDetail(0));

  end
  else
  begin
    MainDataset.Locate('Id', ARecordId.ToInteger, []);
    Await(MainData.OpenCostingDetail(ARecordId.toInteger));

  end;

  AForm := TCostingEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.IdField := FIdField;

    Await(TCostingEditForm, AForm.Load());
    Await(AForm.InitForm);

    AForm.Dataset := MainDataset;

    Await(TModalResult, AForm.Execute);

  finally
    AForm.Free;
    AForm := nil;

    LoadData;

  end;

end;

procedure TCostingListForm.LoadData;
begin
  StandardLoadData;

end;

procedure TCostingListForm.PrepareForm;
begin
  FIdField := 'Id';

  MainDataset.Connection := MainData.DataConnection;

end;

procedure TCostingListForm.SearchData(const Value: string);
begin
  inherited;

end;

procedure TCostingListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  cbPageSizeChange(cbPageSize);

end;

function TCostingListForm.InitSortCol: Integer;
begin
  // default sorting by valid from date
  Result := 2;

end;

function TCostingListForm.InitSortDirection: TSortDirection;
begin
  // default to descending sort order
  Result := sdDesc;

end;


procedure TCostingListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetTitle := TStringField.Create(Self);
  MainDatasetValidFrom := TDateTimeField.Create(Self);
  MainDatasetValidTo := TDateTimeField.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  DataTable.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetTitle.BeforeLoadDFMValues;
  MainDatasetValidFrom.BeforeLoadDFMValues;
  MainDatasetValidTo.BeforeLoadDFMValues;
  try
    Name := 'CostingListForm';
    Caption := 'n';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.Left := 32;
    lbPaginationInfo.Top := 365;
    DataTable.ElementClassName := 'COSTING';
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Title';
      Title := 'Title';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ValidFrom';
      Title := 'Valid From';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ValidTo';
      Title := 'Valid To';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
      Width := 100;
    end;
    MainDataset.EntitySetName := 'Costing';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetTitle.SetParentComponent(MainDataset);
    MainDatasetTitle.Name := 'MainDatasetTitle';
    MainDatasetTitle.FieldName := 'Title';
    MainDatasetTitle.Size := 50;
    MainDatasetValidFrom.SetParentComponent(MainDataset);
    MainDatasetValidFrom.Name := 'MainDatasetValidFrom';
    MainDatasetValidFrom.FieldName := 'ValidFrom';
    MainDatasetValidTo.SetParentComponent(MainDataset);
    MainDatasetValidTo.Name := 'MainDatasetValidTo';
    MainDatasetValidTo.FieldName := 'ValidTo';
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    DataTable.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetTitle.AfterLoadDFMValues;
    MainDatasetValidFrom.AfterLoadDFMValues;
    MainDatasetValidTo.AfterLoadDFMValues;
  end;
end;

end.